var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackpackHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29378",
    "data-name": "Group 29378",
    transform: "translate(-355 -182.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(355 182.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_7_",
    "data-name": "svgexport-17 (7)",
    transform: "translate(373 189.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49974",
    "data-name": "Path 49974",
    d: "M55.5,339.635V336.5h2.743v4.31H56.676A1.176,1.176,0,0,1,55.5,339.635Z",
    transform: "translate(-55.108 -324.019)",
    fill: "#aa6f3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49975",
    "data-name": "Path 49975",
    d: "M57.459,340.81h-.784a1.176,1.176,0,0,1-1.176-1.176V336.5h.784v3.135A1.176,1.176,0,0,0,57.459,340.81Z",
    transform: "translate(-55.108 -324.019)",
    fill: "#9e653b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49976",
    "data-name": "Path 49976",
    d: "M48.243,298.459H45.892a.392.392,0,0,1-.392-.392v-.784a.784.784,0,0,1,.784-.784h1.959Z",
    transform: "translate(-45.5 -285.587)",
    fill: "#c1773d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49977",
    "data-name": "Path 49977",
    d: "M46.676,298.459h-.784a.392.392,0,0,1-.392-.392v-.784a.783.783,0,0,1,.784-.784v1.567A.392.392,0,0,0,46.676,298.459Zm14.93,2.743v-3.135H58.862v4.31H60.43A1.176,1.176,0,0,0,61.605,301.2Z",
    transform: "translate(-45.5 -285.587)",
    fill: "#aa6f3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49978",
    "data-name": "Path 49978",
    d: "M396.5,298.459h2.351a.392.392,0,0,0,.392-.392v-.784a.784.784,0,0,0-.784-.784H396.5Z",
    transform: "translate(-382.746 -285.587)",
    fill: "#c1773d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49979",
    "data-name": "Path 49979",
    d: "M102.364,92.566h-9.8A1.567,1.567,0,0,1,91,91V76.5h12.931V91A1.567,1.567,0,0,1,102.364,92.566Z",
    transform: "translate(-89.217 -74.208)",
    fill: "#f19b40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49980",
    "data-name": "Path 49980",
    d: "M103.931,196.49v.588a1.955,1.955,0,0,1-1.567.784h-9.8A1.955,1.955,0,0,1,91,197.078v-.588a1.955,1.955,0,0,0,1.567.784h9.8a1.955,1.955,0,0,0,1.567-.784Z",
    transform: "translate(-89.217 -189.496)",
    fill: "#d88646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49981",
    "data-name": "Path 49981",
    d: "M274.919,340.81h-3.527a.392.392,0,0,1-.392-.392V336.5h4.31v3.919A.392.392,0,0,1,274.919,340.81Z",
    transform: "translate(-262.164 -324.019)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49982",
    "data-name": "Path 49982",
    d: "M275.31,361.5v.588l-1.486.54a1.962,1.962,0,0,1-1.339,0l-1.486-.54V361.5l1.486.54a1.962,1.962,0,0,0,1.339,0Z",
    transform: "translate(-262.164 -348.04)",
    fill: "#f19b40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49983",
    "data-name": "Path 49983",
    d: "M275.31,328.067l-1.486.54a1.959,1.959,0,0,1-1.339,0l-1.486-.54v-1.176a.392.392,0,0,1,.392-.392h3.527a.392.392,0,0,1,.392.392Z",
    transform: "translate(-262.164 -314.411)",
    fill: "#ffc980"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 0.294,
    cy: 0.294,
    rx: 0.294,
    ry: 0.294,
    transform: "translate(10.698 13.217)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49984",
    "data-name": "Path 49984",
    d: "M134.919,340.81h-3.527a.392.392,0,0,1-.392-.392V336.5h4.31v3.919A.392.392,0,0,1,134.919,340.81Z",
    transform: "translate(-127.65 -324.019)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49985",
    "data-name": "Path 49985",
    d: "M135.31,361.5v.588l-1.486.54a1.962,1.962,0,0,1-1.339,0l-1.486-.54V361.5l1.486.54a1.962,1.962,0,0,0,1.339,0Z",
    transform: "translate(-127.65 -348.04)",
    fill: "#f19b40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49986",
    "data-name": "Path 49986",
    d: "M135.31,328.067l-1.486.54a1.96,1.96,0,0,1-1.339,0l-1.486-.54v-1.176a.392.392,0,0,1,.392-.392h3.527a.392.392,0,0,1,.392.392Z",
    transform: "translate(-127.65 -314.411)",
    fill: "#ffc980"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_429",
    "data-name": "Ellipse 429",
    cx: 0.294,
    cy: 0.294,
    rx: 0.294,
    ry: 0.294,
    transform: "translate(5.212 13.217)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49987",
    "data-name": "Path 49987",
    d: "M103.587,35.771a1.564,1.564,0,0,1-1.223.588h-9.8A1.567,1.567,0,0,1,91,34.791v-14.5h.784V34.6a1.176,1.176,0,0,0,1.176,1.176Zm-4.358-14.44a.294.294,0,0,1-.294-.294v-.98a1.469,1.469,0,1,0-2.939,0v.98a.294.294,0,0,1-.588,0v-.98a2.057,2.057,0,1,1,4.114,0v.98A.294.294,0,0,1,99.229,21.331Z",
    transform: "translate(-89.217 -18)",
    fill: "#d88646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49988",
    "data-name": "Path 49988",
    d: "M92.756,72.378h-9.8A1.959,1.959,0,0,1,81,70.419V66.892a.392.392,0,0,1,.392-.392H94.323a.392.392,0,0,1,.392.392v3.527A1.959,1.959,0,0,1,92.756,72.378Z",
    transform: "translate(-79.609 -64.6)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49989",
    "data-name": "Path 49989",
    d: "M83.743,72.378h-.784A1.959,1.959,0,0,1,81,70.419V66.892a.392.392,0,0,1,.392-.392h.392v3.919a1.959,1.959,0,0,0,1.959,1.959Z",
    transform: "translate(-79.609 -64.6)",
    fill: "#f19b40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49990",
    "data-name": "Path 49990",
    d: "M326.784,65.513a.784.784,0,0,1-.784-.784V56.892a.392.392,0,0,1,.392-.392h.784a.392.392,0,0,1,.392.392v7.837A.784.784,0,0,1,326.784,65.513Z",
    transform: "translate(-315.008 -54.991)",
    fill: "#c1773d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49991",
    "data-name": "Path 49991",
    d: "M315.753,186.225h-1.959a.294.294,0,0,1-.294-.294v-1.959a.294.294,0,0,1,.294-.294h1.959a.294.294,0,0,1,.294.294v1.959A.294.294,0,0,1,315.753,186.225Zm-1.665-.588h1.372v-1.371h-1.372Z",
    transform: "translate(-302.998 -177.186)",
    fill: "#ffc980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49992",
    "data-name": "Path 49992",
    d: "M338.794,215.441a.294.294,0,0,1-.294-.294v-1.176a.294.294,0,1,1,.588,0v1.176A.294.294,0,0,1,338.794,215.441Z",
    transform: "translate(-327.019 -206.01)",
    fill: "#ffb155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49993",
    "data-name": "Path 49993",
    d: "M146.784,65.513a.784.784,0,0,1-.784-.784V56.892a.392.392,0,0,1,.392-.392h.784a.392.392,0,0,1,.392.392v7.837A.784.784,0,0,1,146.784,65.513Z",
    transform: "translate(-142.062 -54.991)",
    fill: "#c1773d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49994",
    "data-name": "Path 49994",
    d: "M135.753,186.225h-1.959a.294.294,0,0,1-.294-.294v-1.959a.294.294,0,0,1,.294-.294h1.959a.294.294,0,0,1,.294.294v1.959A.294.294,0,0,1,135.753,186.225Zm-1.665-.588h1.372v-1.371h-1.372Z",
    transform: "translate(-130.052 -177.186)",
    fill: "#ffc980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49995",
    "data-name": "Path 49995",
    d: "M158.794,215.441a.294.294,0,0,1-.294-.294v-1.176a.294.294,0,0,1,.588,0v1.176A.294.294,0,0,1,158.794,215.441Z",
    transform: "translate(-154.072 -206.01)",
    fill: "#ffb155"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackpackHighlighted);
export default __webpack_public_path__ + "static/media/BackpackHighlighted.4183c816fa1fa048915cf37cb74c1c08.svg";
export { ForwardRef as ReactComponent };